import $ from 'jquery';

//import 'materialize-css';

import Hammer from 'materialize-css/js/hammer.min';
import Vel from 'materialize-css/js/velocity.min';
// import 'materialize-css/js/jquery.hammer';
import 'materialize-css/js/dropdown';
import 'materialize-css/js/jquery.easing.1.3';

import 'materialize-css/js/global';

import 'materialize-css/js/forms';
import 'materialize-css/js/waves';
import 'materialize-css/js/sideNav';
import 'materialize-css/js/collapsible';
import 'materialize-css/js/leanModal';
import 'materialize-css/js/toasts';
import 'materialize-css/js/tooltip';

import './picker';
import './picker.date';

// 'materialize-css/js/jquery.hammer'
function jqueryHammer() {
  function hammerify(el, options) {
    var $el = $(el);
    if(!$el.data("hammer")) {
      $el.data("hammer", new Hammer($el[0], options));
    }
  }

  $.fn.hammer = function(options) {
    return this.each(function() {
      hammerify(this, options);
    });
  };

// extend the emit method to also trigger jQuery events
  Hammer.Manager.prototype.emit = (function(originalEmit) {
    return function(type, data) {
      originalEmit.call(this, type, data);
      $(this.element).trigger({
        type: type,
        gesture: data
      });
    };
  })(Hammer.Manager.prototype.emit);
}

jqueryHammer();

window.Hammer = Hammer;
window.Vel = Vel;

//import 'materialize-css/js/date_picker/picker';
//import 'materialize-css/js/date_picker/picker.date';
